import styled from '@emotion/styled/macro';

const Div = styled.div`
  z-index: 1000;
  width: 100dvw;
  height: 100dvh;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  backdrop-filter: blur(10px);
`;
const Img = styled.img`
  width: 72px;
  height: 72px;
`;

const Loading = () => {
  return (
    <Div>
      <Img alt="loading" src="/theme/img/spinner.gif" />
    </Div>
  );
};

export default Loading;
